<app-offer-taken [data]="data | async" [faqUrl]="links.faq"></app-offer-taken>
